import { IdealWorkerProfileCriteriaType } from '@traba/types'

export const CRITERIA_DISPLAY_NAMES: Record<
  IdealWorkerProfileCriteriaType,
  string
> = {
  [IdealWorkerProfileCriteriaType.MAINTAINED_FULL_TIME_JOB]: 'Full-time LI job',
  [IdealWorkerProfileCriteriaType.HAS_RECENT_WORK_EXPERIENCE]:
    'Recent experience',
  [IdealWorkerProfileCriteriaType.SEEKS_CONSISTENT_WORK]: 'Full-time work',
  [IdealWorkerProfileCriteriaType.HAS_RELIABLE_TRANSPORTATION]:
    'Reliable transport',
  [IdealWorkerProfileCriteriaType.LIVES_IN_SUITABLE_ZIPCODE]:
    'In or near region',
  [IdealWorkerProfileCriteriaType.CAN_START_SOON]: 'Can start soon',
  [IdealWorkerProfileCriteriaType.HAS_LIGHT_INDUSTRIAL_EXPERIENCE]:
    'LI experience',
  [IdealWorkerProfileCriteriaType.MATCHING_WAGE_EXPECTATION]:
    'Wage expectation',
}

export const CRITERIA_ORDER = [
  IdealWorkerProfileCriteriaType.MAINTAINED_FULL_TIME_JOB,
  IdealWorkerProfileCriteriaType.HAS_RECENT_WORK_EXPERIENCE,
  IdealWorkerProfileCriteriaType.SEEKS_CONSISTENT_WORK,
  IdealWorkerProfileCriteriaType.LIVES_IN_SUITABLE_ZIPCODE,
  IdealWorkerProfileCriteriaType.HAS_RELIABLE_TRANSPORTATION,
]
